<template>
	<div style="overflow-y: hidden;">
		<el-container>
			<el-header>
				<div style="position: relative;width: 100%;height: 100%;;background-color: #007aff;color: #fff;">
					<span style="position: absolute;right: 10%;top: 1em;">4.1</span>
				</div>
			</el-header>
			<el-container>
				<el-aside width="140px" style="position: relative;height: 100vh;background-color: #fff;">
					<el-menu :router="true" :default-active="activeIndex">
						<el-menu-item index="/home">
							<span>首页</span>
						</el-menu-item>
						<el-menu-item index="/query/waybill">
							<span>查轨迹</span>
						</el-menu-item>
						<el-sub-menu index="/order/createOrder">
							<template #title>
								<span>打单发货</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="/order/createOrder">创建订单</el-menu-item>
								<el-menu-item index="/order/orderList">订单列表</el-menu-item>
							</el-menu-item-group>
						</el-sub-menu>
						<el-sub-menu index="/tool/stopQuery">
							<template #title>
								<span>客服工具</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="/tool/againPrint">运单补打</el-menu-item>
							</el-menu-item-group>
							<el-menu-item-group>
								<el-menu-item index="/tool/stopQuery">停发查询</el-menu-item>
							</el-menu-item-group>
							<el-menu-item-group>
								<el-menu-item index="/tool/orgInfo">网点查询</el-menu-item>
							</el-menu-item-group>
							<el-menu-item-group>
								<el-menu-item index="/tool/goodsRestrictions">禁限寄查询</el-menu-item>
							</el-menu-item-group>
						</el-sub-menu>
						<el-sub-menu index="/finance/customerList">
							<template #title>
								<span>财务结算</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="/finance/priceList">客户价格</el-menu-item>
								<el-menu-item index="/finance/customerList">客户管理</el-menu-item>
								<el-menu-item index="/finance/calculateCarriage">账单生成</el-menu-item>
								<el-menu-item index="/finance/billList">客户账单</el-menu-item>
							</el-menu-item-group>
						</el-sub-menu>
						<el-sub-menu index="/set/expressAccount">
							<template #title>
								<span>设置</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="/set/expressAccount">电子面单</el-menu-item>
								<el-menu-item index="/set/downloadList">下载中心</el-menu-item>
								<el-menu-item index="/set/publicDoc">公开文件</el-menu-item>
							</el-menu-item-group>
						</el-sub-menu>
						<el-menu-item index="/queryWaybill">
							<span>内网运单</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main>
					<router-view></router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	export default {
		name: 'mainFrame',
		data() {
			return {
				activeIndex: '/order/create_order',
			};
		},
		mounted() {
			this.activeIndex = this.$route.path
		},
		methods: {

		}
	}
</script>

<style>
/* 修改导航栏样式 */
.el-header {
    --el-header-padding: 0 0;
	--el-header-height: 40px;
}
/* .el-sub-menu{
	--el-menu-level-padding:0;
} */
.el-menu-item{
	padding-left: 25% !important;
}
.el-menu-item-group__title{
	display: none;
}
</style>